const formAnalytics = {
  methods: {
    submitAnalytics (step) {
      if (this.$v && this.$v.$invalid) {
        this.trackEvent({
          action: 'submit_with_errors',
          label: step
        })
        return
      }
      this.trackEvent({
        action: 'submit_step',
        label: step
      })
    },
    blurField (field, fieldName) {
      field.$touch()
      if (field.$error) {
        this.trackEvent({
          action: 'form_input_error',
          label: fieldName
        })
        return
      }
      this.trackEvent({
        action: 'form_input',
        label: fieldName
      })
    }
  }
}

export default formAnalytics
